import { ILifeChangingEvent } from "motw_core/Entity/ILifeChangingEvent";
import * as React from "react";
import { CartesianGrid, Line, LineChart, XAxis, YAxis } from "recharts/lib";
import { sortBy } from "lodash-es";

export function LCEChart({ data }: { data: ILifeChangingEvent[] }) {
    const graphData = sortBy(data, (row) => row.year).map((row) => ({
        year: row.year,
        score: row.perspective * row.rating!,
    }));

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                overflowX: "auto", // Enables horizontal scrolling on smaller screens
                overflowY: "hidden", // Prevents vertical scrolling
                WebkitOverflowScrolling: "touch", // Smooth scrolling for mobile devices
                msOverflowStyle: "none", // Hides scrollbar for IE/Edge
                scrollbarWidth: "none", // Hides scrollbar for Firefox
            }}
        >
            <div
                style={{
                    minWidth: "600px", // Ensures the chart maintains its minimum width
                }}
            >
                <LineChart
                    width={600}
                    height={300}
                    data={graphData}
                    margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
                >
                    <Line
                        type="monotone"
                        dataKey="score"
                        stroke="darkgoldenrod"
                        strokeWidth={3}
                    />
                    <CartesianGrid stroke="dimgray" strokeDasharray="5 5" />
                    <XAxis dataKey="year" />
                    <YAxis scale="log" domain={[10, "auto"]} />
                </LineChart>
            </div>
        </div>
    );
}
